import JustValidate from "just-validate";
import $ from "jquery";
import { HCP_API_URL, API_KEY, getReferralSource } from "./main";


export const submitContactForm = (formEl) => {
    if (!formEl) return;
    const $form = $(formEl);
    const contactedByRep = $form.find("#field-representative").is(":checked") ? "Yes" : "No";
    const nowIso = new Date().toISOString().replace(/\.\d{3}Z$/, "");
    const payload = {
        FirstName: $form.find("#field-1-name").val()?.trim() || "",
        LastName: $form.find("#field-2-last").val()?.trim() || "",
        EmailAddress: $form.find("#email").val()?.trim() || "",
        PhoneNumber: $form.find("#phone").val()?.trim() || "",
        Address1: $form.find("#field-address-one").val()?.trim() || "",
        Address2: $form.find("#field-address-two").val()?.trim() || "",
        City: $form.find("#field-city").val()?.trim() || "",
        State: $form.find("#field-state").val()?.trim() || "",
        Zip: $form.find("#field-zipcode").val()?.trim() || "",
        Profession: $form.find("#profession option:selected").text(),
        // Profession: $form.find("#profession").val()?.trim() || "",
        Specialty: $form.find("#specialty option:selected").text(),
        // Specialty: $form.find("#specialty").val()?.trim() || "",
        ContactedByRep: contactedByRep,
        OptInDate: nowIso,
        OriginSource: "Pemgarda: Website",
        ReferralSource: getReferralSource(),
        CreateDate: nowIso,
        Status: "Active",
    };
    return $.ajax({
        url: `${HCP_API_URL}`,
        method: "POST",
        headers: {
            "accept": "*/*",
            "x-api-key": API_KEY,
            "Content-Type": "application/json",
        },
        data: JSON.stringify(payload),
    })
        .done(function () {
            formEl.reset();
            const contactFormEl = document.querySelector(".contact-form");
            const contactFormSuccess = document.querySelector(".contact-form-success");
            const introText = document.querySelector(".contact-form-intro");
            if (contactFormEl && contactFormSuccess) {
                contactFormEl.style.display = "none";
                contactFormSuccess.classList.remove("hidden");
                if (introText) {
                    introText.style.display = "none";
                }
            }
        })
        .fail(function () {
            const formError = document.querySelector(".form-error");
            const message = "We're unable to submit the form right now. Please try again later.";
            if (formError) {
                formError.textContent = message;
                formError.style.display = "block";
                formError.scrollIntoView({ behavior: "smooth", block: "center" });
            } else {
                alert(message);
            }
        });
};

export const contactForm = () => {
    const contact = document.querySelector('#contact-form');
    const steps = document.querySelector('.steps');
    const validateForm = new JustValidate('#contact-form');
    const state = contact.querySelector('#field-state');

    window.contactFormValidation = validateForm;
    const navigatePage = contact.querySelectorAll('.navigate-page button');

    validateForm.addField('#field-1-name', [
        { rule: 'required', errorMessage: 'Please enter your first name' }
    ]).addField('#field-2-last', [
        { rule: 'required', errorMessage: 'Please enter your last name' }
    ]).addField('#phone', [
        { rule: 'required', errorMessage: 'Please enter your phone number' }
    ]).addField('#email', [
        { rule: 'required', errorMessage: 'Please enter your email' },
        { rule: 'email' }
    ]).addField('#profession', [
        { rule: 'required', errorMessage: 'Please select one' }
    ]).addField('#field-address-one', [
        { rule: 'required', errorMessage: 'Please enter your address' }
    ]).addField('#field-address-two', [
        { rule: 'required', errorMessage: 'Please enter your address' }
    ]).addField('#field-city', [
        { rule: 'required', errorMessage: 'Please enter your city' }
    ]).addField('#field-state', [
        { rule: 'required', errorMessage: 'Please enter your state' }
    ]).addField('#field-zipcode', [
        { rule: 'required', errorMessage: 'Please enter your zip code' },
        { rule: 'number' }
    ]).addField('#field-terms-conditions', [
        { rule: 'required', errorMessage: 'Please check box to agree' }
    ])
        .onSuccess((event) => {
            event.preventDefault();
            submitContactForm(event.target);
        })

    const checkBeforeNext = (el, target, nth) => {
        let count = 0;

        const scrollPostion = contact.offsetTop;
        for (const field in validateForm.fields) {
            if (field <= nth && validateForm.fields[field].isValid == true) {
                count += 1;
                if (count == nth) {
                    console.log(validateForm.fields[field].isValid)
                    el.parentElement.parentElement.parentElement.classList.remove('active')
                    contact.querySelector(`#${target}`).classList.add('active')
                    steps.querySelector(`[data-check="${target}"]`).previousElementSibling != null ? steps.querySelector(`[data-check="${target}"]`).previousElementSibling.classList.add('completed') : steps.querySelector(`[data-check="${target}"]`).classList.remove('completed')
                    steps.querySelector('.active').classList.remove('active')
                    steps.querySelector(`[data-check="${target}"]`).classList.add('active');
                    steps.querySelector('.active').classList.contains('completed') ? steps.querySelector('.active').classList.remove('completed') : ''

                    window.scrollTo({
                        top: scrollPostion,
                        behavior: "smooth",
                    });

                }
            }
            // 
        }
    }

    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                // console.log('Attribute value changed to:', state.value);
                window.customSelect[2].setSelected(state.value)
            }
        }
    });
    observer.observe(state, { attributes: true });

    navigatePage.forEach((el) => {

        el.addEventListener('click', () => {
            const target = el.getAttribute('data-target');
            const elParents = el.parentElement.parentElement.parentElement;
            if (elParents.getAttribute('id') == `contact-form-page-1` || el.getAttribute('data-target') == `contact-form-page-1`) {
                validateForm.revalidateField('#field-1-name')
                validateForm.revalidateField('#field-2-last')
                validateForm.revalidateField('#phone')
                validateForm.revalidateField('#email')
                checkBeforeNext(el, target, 4)
            } else if (elParents.getAttribute('id') == `contact-form-page-2` || el.getAttribute('data-target') == `contact-form-page-2`) {
                validateForm.revalidateField('#profession')
                // validateForm.revalidateField('#specialty')
                checkBeforeNext(el, target, 5)
            }

        })
    })
}
